// import { makeid } from "../../../components/commonFunction";

export const makeid = () => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < 5; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

// Material UI Avaoidable types

// elementType,	union: node , func

export const componentsConfig = [
  {
    componentName: "Container",
    componentId: "material-comp-1",
    frameWork: "material",
    componentType: "layout",
    isLayout: true,
    groupName: ["web", "app"],
    props: {
      disableGutters: {
        type: "select",
        options: [true, false],
      },
      maxWidth: {
        type: "dropdown",
        options: ["lg", "md", "sm", "xl", "xs", false],
      },
      fixed: {
        type: "select",
        options: [true, false],
      },
    },
  },
  {
    componentName: "Button",
    componentId: "material-comp-2",
    frameWork: "material",
    componentType: "input",
    isLayout: false,
    groupName: ["web", "app"],
    props: {
      children: {
        type: "text",
        defaultValue: "button",
      },
      disabled: {
        type: "select",
        options: [true, false],
      },
      inputProps: {
        type: "object",
        keyVal: [
          {
            type: "date",
            min: "2022-01-02",
          },
        ],
      },
      disableElevation: {
        type: "select",
        options: [true, false],
      },
      disableFocusRipple: {
        type: "select",
        options: [true, false],
      },
      disableRipple: {
        type: "select",
        options: [true, false],
      },
      fullWidth: {
        type: "select",
        options: [true, false],
      },
      endIcon: {
        type: "icons",
      },
      startIcon: {
        type: "icons",
      },
      href: {
        type: "text",
      },
      size: {
        type: "dropdown",
        options: ["large", "medium", "small"],
      },
      variant: {
        type: "dropdown",
        options: ["contained", "outlined", "text"],
      },
    },
  },
  {
    componentName: "Box",
    componentId: "material-comp-3",
    frameWork: "material",
    componentType: "layout",
    isLayout: true,
    groupName: ["web", "app"],
    props: {},
  },
  {
    componentName: "Switch",
    componentId: "material-comp-4",
    frameWork: "material",
    componentType: "input",
    isLayout: true,
    groupName: ["web", "app"],
    props: {
      checked: {
        type: "select",
        options: [true, false],
      },
      disabled: {
        type: "select",
        options: [true, false],
      },
      disableRipple: {
        type: "select",
        options: [true, false],
      },
      checkedIcon: {
        type: "icons",
      },
      icon: {
        type: "icons",
      },
      color: {
        type: "dropdown",
        options: ["default", "primary", "secondary"],
      },
      required: {
        type: "select",
        options: [true, false],
      },
      size: {
        type: "dropdown",
        options: ["medium", "small"],
      },
      edge: {
        type: "dropdown",
        options: ["end", "start", "false"],
      },
    },
  },
];

// all component panel list
export const ComponentsLists = [
  {
    catagerie: "layouts",
    list: [
      {
        name: "Container",
      },
      {
        name: "Col",
      },
      {
        name: "Row",
      },
      {
        name: "Hidden",
      },
      {
        name: "Divider",
      },
      { name: "Paper" },
      {
        name: "Card",
      },
      { name: "CardActions" },
      { name: "CardContent" },
      { name: "CardHeader" },
      { name: "CardMedia" },
      { name: "ButtonGroup" },
      { name: "List" },
      { name: "ListItem" },
      { name: "Image" },
      { name: "Dropdown" },
      { name: "Tab" },
      { name: "Collapse" },
      { name: "Tabpanel" },
    ],
  },
  {
    catagerie: "inputs",
    list: [
      {
        name: "Button",
      },
      {
        name: "Select",
      },
      {
        name: "Link",
      },
      {
        name: "TextInput",
      },
      {
        name: "TextArea",
      },
      { name: "Switch" },
      { name: "Radio" },
      {
        name: "Checkbox",
      },
      { name: "MultiSelect" },
      { name: "RangePicker" },
      { name: "Upload" },
      // { name: "TopSelect" },
      { name: "DateTimepicker" },
    ],
  },
  {
    catagerie: "Data display",
    list: [
      {
        name: "Text",
      },
      {
        name: "H1",
      },
      {
        name: "H2",
      },
      {
        name: "H6",
      },
      {
        name: "Badge",
      },
      { name: "Avatar" },
      { name: "Chip" },
      { name: "Carousel" },
    ],
  },
  {
    catagerie: "Feedbacks",
    list: [
      {
        name: "Alert",
      },
      { name: "CircularProgress" },
      { name: "Drawer" },
      { name: "Modal" },
      { name: "DialogTitle" },
      { name: "DialogActions" },
      { name: "DialogContent" },
      { name: "TopHeader" },
      { name: "Snackbar" },
      { name: "SideMenu" },
      { name: "BorderLinearProgress" },
      { name: "Table" },
    ],
  },
  {
    catagerie: "New Component's",
    list: [
      {
        name: "TapSelect",
      },
      {
        name: "LocationSearch",
      },
      {
        name: "AutoSuggestion",
      },
      {
        name: "BackgroundImage",
      },
      {
        name: "OtpInput",
      },
      {
        name: "WeekCalendar",
      },
      {
        name: "Icons",
      },
      {
        name: "Div",
      },
      {
        name: "Translate",
      },
      {
        name: "MobileNumberWithCode",
      },
      {
        name: "Form",
      },
      {
        name: "CustomForm",
      },
      {
        name: "Chart",
      },
      {
        name: "MockUI",
      },
      {
        name: "CustomCode",
      },
      {
        name: "QRscan",
      },
      // {
      //   name: "AinqaFlex",
      // },
      // {
      //   name: "Div"
      // },
      // {
      //   name: "MobileNumberWithCode"
      // }
    ],
  },
  {
    catagerie: "function library",
    list: [
      {
        name: "IdmPanel",
      },
    ],
  },
];

export const DynamicComponentsList = [
  { name: "Chart" },
  { name: "CustomForm" },
  { name: "MockUI" },
  { name: "CustomCode" },
];

export const DynamicComponentsDefaultproperties = {
  Chart: {
    chartType: "Select",
    chartData: {
      data: [
        ["labelTitle", "DatasetTitle1", "DatasetTitle2"],
        ["label", 5, 12],
      ],
      options: {
        title: "Your chart",
        titleTextStyle: {
          fontSize: 20,
        },
        isStacked: false,
        isColumn: false,
        colors: [
          {
            color: "#ADD8E6",
          },
          {
            color: "#b0120a",
          },
        ],
        legend: {
          position: "bottom",
          alignment: "center",
          textStyle: {
            color: "#000",
            fontSize: 16,
          },
        },
        hAxis: {
          title: "Total Population",
        },
        vAxis: {
          title: "City",
        },
      },
    },
  },
  CustomForm: {
    id: "",
  },
};
// all screen list -- only for local usage
export const AllScreenList = [
  {
    id: "U2ZYK",
    pathId: "lw8Oo",
    arrowLink: [],
    name: "Login",
    description: "Login screen main landing page",
    path: "/",
    isHome: true,
    render: {
      component: "div",
      component_type: "qdm",
      child: [
        {
          type: "component",
          component: "Container",
          component_type: "qdm",
          name: "Container",
          id: "0TuCU",
          attr: null,
          child: [
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "L9OqR",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "lQutc",
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Avatar",
                      component_type: "qdm",
                      name: "Avatar",
                      id: "uOErf",
                      attr: null,
                      properties: {
                        variant: "circle",
                        letter: "Avatar",
                        src: "http://167.71.228.116:3306/images/tanyaCare/login_top_logo/tanyaCareTopLogo-light.png",
                        alt: "Image",
                      },
                      inlineStyles: {
                        backgroundColor: "#fff",
                        borderRadius: "0px",
                        margin: "0px",
                        height: "40px",
                        width: "120px",
                      },
                    },
                  ],
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: 2,
              },
              inlineStyles: {
                padding: "20px",
              },
            },
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "kaAdK",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "rVNyk",
                  attr: null,
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "6",
                    xs: 12,
                    md: "6",
                    sm: 12,
                  },
                  inlineStyles: {
                    textAlign: "center",
                  },
                  child: [
                    {
                      type: "component",
                      component: "Row",
                      component_type: "qdm",
                      name: "Row",
                      id: "jXXPx",
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Avatar",
                          component_type: "qdm",
                          name: "Avatar",
                          id: "rXZeF",
                          attr: null,
                          properties: {
                            variant: "circle",
                            letter: "Avatar",
                            src: "http://167.71.228.116:3306/images/tanyaCare/login_page_logo/tanyaCareLogo-light.png",
                            alt: "Image",
                          },
                          inlineStyles: {
                            margin: "auto",
                            borderRadius: "0px",
                            backgroundColor: "#fff",
                            width: "312px",
                            height: "312px",
                          },
                        },
                      ],
                      properties: {
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        spacing: 2,
                      },
                      inlineStyles: {
                        display: "",
                      },
                    },
                    {
                      type: "component",
                      component: "Row",
                      component_type: "qdm",
                      name: "Row",
                      id: "kmr7a",
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: "xh4GN",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Text",
                              component_type: "qdm",
                              name: "Text",
                              id: "5102d02b-ae9b-4495-8980-77810db4b8f0",
                              attr: null,
                              properties: {
                                name: "Leveraging the power of a connected community, towards the empowerment of health, wellness and care for individuals and families.",
                              },
                              inlineStyles: {
                                textAlign: "center",
                              },
                            },
                            {
                              type: "component",
                              component: "H6",
                              component_type: "qdm",
                              name: "H6",
                              id: "f2626c78-823a-4d67-9388-d8238ea09440",
                              attr: null,
                              properties: {
                                name: "TANYA is just an ask away for better care",
                              },
                              inlineStyles: {
                                fontSize: "1rem",
                                color: "#363a57",
                                marginTop: "14px",
                              },
                            },
                          ],
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: 12,
                            xs: 12,
                            md: 12,
                            sm: 12,
                          },
                          inlineStyles: {
                            textAlign: "center",
                          },
                        },
                      ],
                      properties: {
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        spacing: 2,
                      },
                      inlineStyles: {
                        padding: "24px",
                      },
                    },
                  ],
                },
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "A6apv",
                  attr: null,
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "6",
                    xs: 12,
                    md: "6",
                    sm: 12,
                  },
                  inlineStyles: {
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                  child: [
                    {
                      type: "component",
                      component: "Row",
                      component_type: "qdm",
                      name: "Row",
                      id: "8MJnM",
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: "g46cE",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "H6",
                              component_type: "qdm",
                              name: "H6",
                              id: "8c362c47-189b-4b6d-847a-dffb781630ba",
                              attr: null,
                              properties: {
                                name: "Welcome Back",
                              },
                              inlineStyles: {
                                color: "#363a57",
                                fontSize: "1.5rem",
                              },
                            },
                          ],
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: 12,
                            xs: 12,
                            md: 12,
                            sm: 12,
                          },
                          inlineStyles: {
                            textAlign: "center",
                          },
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: "7QDp6",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Text",
                              component_type: "qdm",
                              name: "Text",
                              id: "6089fa16-302e-4430-8ff0-aa6af8051dec",
                              attr: null,
                              properties: {
                                name: "Enter your credentials to proceed",
                              },
                              inlineStyles: {
                                color: "#9297a5",
                                fontSize: "1rem",
                                marginBottom: "",
                                paddingBottom: "",
                              },
                            },
                          ],
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: 12,
                            xs: 12,
                            md: 12,
                            sm: 12,
                          },
                          inlineStyles: {
                            textAlign: "center",
                            marginBottom: "20px",
                          },
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: "GHjYr",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",
                              id: "a4126732-96a7-474f-9c6c-29ebeb8bdfed",
                              attr: null,
                              properties: {
                                type: "email",
                                name: "text",
                                size: "medium",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "Email Address",
                                autoFocus: false,
                              },
                              inlineStyles: {},
                            },
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",
                              id: "90e797f4-a989-47a7-a807-ff98172ac53a",
                              attr: null,
                              properties: {
                                type: "text",
                                name: "text",
                                size: "medium",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "Password",
                                autoFocus: false,
                              },
                              inlineStyles: {},
                            },
                            {
                              type: "component",
                              component: "Button",
                              component_type: "qdm",
                              name: "Button",
                              id: "f9740b9d-4be0-47a9-9eaa-afbba9696de7",
                              attr: null,
                              properties: {
                                type: "submit",
                                color: "secondary",
                                size: "medium",
                                variant: "outlined",
                                name: "Sign In",
                              },
                              inlineStyles: {
                                width: "100%",
                                backgroundColor: "#009490",
                                borderColor: "#009490",
                                borderRadius: "8px",
                              },
                            },
                          ],
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "12",
                            xs: 12,
                            md: 12,
                            sm: 12,
                          },
                          inlineStyles: {},
                        },
                      ],
                      properties: {
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        spacing: 2,
                      },
                      inlineStyles: {
                        textAlign: "",
                        padding: "40px",
                      },
                    },
                  ],
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: "0",
              },
              inlineStyles: {
                padding: "20px",
              },
            },
          ],
          properties: {
            name: "container",
            fluid: false,
          },
          inlineStyles: {
            backgroundColor: "#fff",
            height: "100vh",
          },
        },
      ],
    },
  },
  {
    id: "fIU7B",
    pathId: "zFmOu",
    name: "Providers List",
    description: "Providers List Screen",
    path: "/providers",
    render: {
      component: "div",
      component_type: "qdm",
      child: [
        {
          type: "component",
          component: "Container",
          component_type: "qdm",
          name: "Container",
          id: "otiVq",
          attr: null,
          child: [
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "m4VKi",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "RsJWG",
                  attr: null,
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "6",
                    xs: "6",
                    md: "6",
                    sm: "6",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  },
                  child: [
                    {
                      type: "component",
                      component: "Avatar",
                      component_type: "qdm",
                      name: "Avatar",
                      id: "GXgoy",
                      attr: null,
                      properties: {
                        variant: "circle",
                        letter: "Avatar",
                        src: "https://www.pinclipart.com/picdir/middle/544-5440422_back-arrow-icon-transparent-png-clipart-free-download.png",
                        alt: "Image",
                      },
                      inlineStyles: {
                        margin: "0px",
                        marginRight: "14px",
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#f5f5f5",
                      },
                    },
                    {
                      type: "component",
                      component: "Text",
                      component_type: "qdm",
                      name: "Text",
                      id: "iKPqQ",
                      attr: null,
                      properties: {
                        name: "Providers",
                      },
                      inlineStyles: {
                        fontSize: "20px",
                        fontWeight: "500",
                      },
                    },
                  ],
                },
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "52Ero",
                  attr: null,
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "6",
                    xs: "6",
                    md: "6",
                    sm: "6",
                  },
                  inlineStyles: {
                    textAlign: "right",
                  },
                  child: [
                    {
                      type: "component",
                      component: "H6",
                      component_type: "qdm",
                      name: "H6",
                      id: "E0cEP",
                      attr: null,
                      properties: {
                        name: "Ajay Crayond",
                      },
                      inlineStyles: {
                        fontSize: "14px",
                        fontWeight: "400",
                      },
                    },
                    {
                      type: "component",
                      component: "Text",
                      component_type: "qdm",
                      name: "Text",
                      id: "xGwY8",
                      attr: null,
                      properties: {
                        name: "Admin",
                      },
                      inlineStyles: {
                        color: "#9297a5",
                      },
                    },
                  ],
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: 2,
              },
              inlineStyles: {
                padding: "10px",
                backgroundColor: "#f5f5f5",
                borderColor: "#e0e0e0d6",
                borderWidth: "1px",
                borderStyle: "solid",
                marginBottom: "",
              },
            },
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "cZoIj",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "Jxxc2",
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Select",
                      component_type: "qdm",
                      name: "Select",
                      id: "TPnue",
                      attr: null,
                      properties: {
                        disabled: false,
                        size: "medium",
                        helperTextType: "error",
                        label: "Search for provider Name",
                        variant: "outlined",
                      },
                      inlineStyles: {
                        width: "",
                      },
                    },
                  ],
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "8",
                    xs: 12,
                    md: "8",
                    sm: 12,
                  },
                  inlineStyles: {},
                },
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "siTha",
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Dropdown",
                      component_type: "qdm",
                      name: "Dropdown",
                      id: "Stk71",
                      attr: null,
                      properties: {
                        title: "Most Recent",
                        value: [
                          {
                            name: "List",
                            url: "#",
                          },
                        ],
                      },
                      inlineStyles: {
                        backgroundColor: "#f5f4f5",
                        marginRight: "10px",
                        width: "",
                        borderColor: "",
                        borderRadius: "4px",
                      },
                    },
                    {
                      type: "component",
                      component: "Button",
                      component_type: "qdm",
                      name: "Button",
                      id: "80Eq8",
                      attr: null,
                      properties: {
                        type: "button",
                        color: "primary",
                        size: "medium",
                        variant: "outlined",
                        name: "+ ADD PROVIDER",
                      },
                      inlineStyles: {
                        backgroundColor: "#009490",
                        borderColor: "#009490",
                        borderRadius: "8px",
                      },
                    },
                  ],
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "4",
                    xs: 12,
                    md: "4",
                    sm: 12,
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  },
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: 2,
              },
              inlineStyles: {
                paddingTop: "",
                padding: "14px",
              },
            },
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "wmyxH",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "gwmmd",
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "H6",
                      component_type: "qdm",
                      name: "H6",
                      id: "EEqVK",
                      attr: null,
                      properties: {
                        name: "Total Providers",
                      },
                      inlineStyles: {},
                    },
                  ],
                },
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "Rp0Em",
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "List",
                      component_type: "qdm",
                      name: "List",
                      id: "4a404e5d-5f2a-4132-85d0-af5a9336fd05",
                      attr: null,
                      properties: {
                        children: "List",
                      },
                      inlineStyles: {
                        backgroundColor: "#f5f4f5",
                      },
                      child: [
                        {
                          type: "component",
                          component: "ListItem",
                          component_type: "qdm",
                          name: "ListItem",
                          id: "YhwGD",
                          attr: null,
                          properties: {
                            title: "Vasan Dental Clinic",
                            description: "List Item Descaription",
                          },
                          inlineStyles: {
                            backgroundColor: "#fff",
                            marginBottom: "20px",
                            borderRadius: "6px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "Row",
                              component_type: "qdm",
                              name: "Row",
                              id: "LSYDl",
                              attr: null,
                              child: [
                                {
                                  type: "component",
                                  component: "Col",
                                  component_type: "qdm",
                                  name: "Col",
                                  id: "b3B0P",
                                  attr: null,
                                  properties: {
                                    name: "qdm-col-12",
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    textAlign: "left",
                                    lg: "9",
                                    xs: "12",
                                    md: "9",
                                    sm: "12",
                                  },
                                  inlineStyles: {
                                    display: "inline-flex",
                                    justifyContent: "",
                                    alignItems: "",
                                    padding: "0px",
                                    paddingTop: "",
                                    paddingLeft: "",
                                    paddingBottom: "",
                                    paddingRight: "",
                                  },
                                  child: [
                                    {
                                      type: "component",
                                      component: "Row",
                                      component_type: "qdm",
                                      name: "Row",
                                      id: "DZELx",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Avatar",
                                          component_type: "qdm",
                                          name: "Avatar",
                                          id: "PEkrR",
                                          attr: null,
                                          properties: {
                                            variant: "circle",
                                            letter: "Avatar",
                                            src: "https://image.freepik.com/free-vector/healthcare-logo_10250-3453.jpg",
                                            alt: "Image",
                                          },
                                          inlineStyles: {
                                            margin: "0px",
                                            marginRight: "14px",
                                          },
                                        },
                                      ],
                                      properties: {
                                        alignItems: "stretch",
                                        direction: "row",
                                        justify: "flex-start",
                                        spacing: 2,
                                      },
                                      inlineStyles: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        padding: "0px",
                                      },
                                    },
                                    {
                                      type: "component",
                                      component: "Row",
                                      component_type: "qdm",
                                      name: "Row",
                                      id: "WqDPT",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Col",
                                          component_type: "qdm",
                                          name: "Col",
                                          id: "uykvS",
                                          attr: null,
                                          child: [
                                            {
                                              type: "component",
                                              component: "Text",
                                              component_type: "qdm",
                                              name: "Text",
                                              id: "CBunA",
                                              attr: null,
                                              properties: {
                                                name: "Vasan Dental Clinic",
                                              },
                                              inlineStyles: {
                                                marginRight: "10px",
                                                fontSize: "1rem",
                                              },
                                            },
                                            {
                                              type: "component",
                                              component: "Text",
                                              component_type: "qdm",
                                              name: "Text",
                                              id: "FrNae",
                                              attr: null,
                                              properties: {
                                                name: "• ACTIVE",
                                              },
                                              inlineStyles: {
                                                color: "#31b198",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                              },
                                            },
                                          ],
                                          properties: {
                                            name: "qdm-col-12",
                                            alignItems: "stretch",
                                            direction: "row",
                                            justify: "flex-start",
                                            textAlign: "left",
                                            lg: 12,
                                            xs: 12,
                                            md: 12,
                                            sm: 12,
                                          },
                                          inlineStyles: {
                                            padding: "0px",
                                          },
                                        },
                                        {
                                          type: "component",
                                          component: "Col",
                                          component_type: "qdm",
                                          name: "Col",
                                          id: "dZFtz",
                                          attr: null,
                                          child: [
                                            {
                                              type: "component",
                                              component: "Chip",
                                              component_type: "qdm",
                                              name: "Chip",
                                              id: "UctmZ",
                                              attr: null,
                                              properties: {
                                                variant: "circle",
                                                name: "Chip",
                                              },
                                              inlineStyles: {
                                                margin: "0px",
                                                padding: "",
                                                borderRadius: "4px",
                                                backgroundColor: "#f4f4f5",
                                                paddingTop: "5px",
                                                paddingBottom: "5px",
                                                paddingLeft: "10px",
                                                paddingRight: "10px",
                                                color: "#9297a5",
                                                fontSize: "14px",
                                                borderColor: "#f4f4f5",
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  type: "component",
                                  component: "Col",
                                  component_type: "qdm",
                                  name: "Col",
                                  id: "7VTqm",
                                  attr: null,
                                  properties: {
                                    name: "qdm-col-12",
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    textAlign: "left",
                                    lg: "3",
                                    xs: "12",
                                    md: "3",
                                    sm: "12",
                                  },
                                  inlineStyles: {
                                    textAlign: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  },
                                  child: [
                                    {
                                      type: "component",
                                      component: "Row",
                                      component_type: "qdm",
                                      name: "Row",
                                      id: "ahZh5",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "H6",
                                          component_type: "qdm",
                                          name: "H6",
                                          id: "582b8f1a-53bc-4cac-9669-f390423bc5af",
                                          attr: null,
                                          properties: {
                                            name: "1",
                                          },
                                          inlineStyles: {},
                                        },
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "a849fba5-7bc8-466e-a995-0e87c8f1c02a",
                                          attr: null,
                                          properties: {
                                            name: "Branches",
                                          },
                                          inlineStyles: {
                                            color: "#9297a5",
                                          },
                                        },
                                      ],
                                      properties: {
                                        alignItems: "stretch",
                                        direction: "row",
                                        justify: "flex-start",
                                        spacing: 2,
                                      },
                                      inlineStyles: {
                                        display: "block",
                                      },
                                    },
                                  ],
                                },
                              ],
                              properties: {
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                spacing: 2,
                              },
                              inlineStyles: {
                                width: "100%",
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: 2,
              },
              inlineStyles: {
                padding: "",
                paddingLeft: "14px",
                paddingRight: "14px",
              },
            },
          ],
          properties: {
            name: "container",
            fluid: true,
          },
          inlineStyles: {
            backgroundColor: "#F4F4F5",
            padding: "0px",
            height: "100vh",
          },
        },
      ],
    },
  },
  {
    id: "ghN1n",
    pathId: "myB33",
    name: "Provider Details",
    description: "Provider Details Screen",
    path: "/providerDetails",
    render: {
      component: "div",
      component_type: "qdm",
      child: [
        {
          type: "component",
          component: "Container",
          component_type: "qdm",
          name: "Container",
          id: "TUMhx",
          attr: null,
          properties: {
            name: "container",
            fluid: true,
          },
          inlineStyles: {
            height: "100%",
            backgroundColor: "#f5f4f5",
            textAlign: "",
            padding: "0px",
          },
          child: [
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "SaOyN",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "Jvt9M",
                  attr: null,
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "8",
                    xs: "8",
                    md: "8",
                    sm: "8",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  },
                  child: [
                    {
                      type: "component",
                      component: "Avatar",
                      component_type: "qdm",
                      name: "Avatar",
                      id: "Vt1at",
                      attr: null,
                      properties: {
                        variant: "circle",
                        letter: "Avatar",
                        src: "https://www.pinclipart.com/picdir/middle/544-5440422_back-arrow-icon-transparent-png-clipart-free-download.png",
                        alt: "Image",
                      },
                      inlineStyles: {
                        backgroundColor: "#f5f5f5",
                        width: "20px",
                        height: "20px",
                        margin: "0px",
                        marginRight: "20px",
                      },
                    },
                    {
                      type: "component",
                      component: "Text",
                      component_type: "qdm",
                      name: "Text",
                      id: "TcoLP",
                      attr: null,
                      properties: {
                        name: "Provider Details",
                      },
                      inlineStyles: {
                        fontSize: "20px",
                        fontWeight: "500",
                      },
                    },
                  ],
                },
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "pijmH",
                  attr: null,
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "4",
                    xs: "4",
                    md: "4",
                    sm: "4",
                  },
                  inlineStyles: {
                    textAlign: "right",
                  },
                  child: [
                    {
                      type: "component",
                      component: "H6",
                      component_type: "qdm",
                      name: "H6",
                      id: "9LZx7",
                      attr: null,
                      properties: {
                        name: "Ajay Crayond",
                      },
                      inlineStyles: {
                        fontSize: "14px",
                        fontWeight: "400",
                      },
                    },
                    {
                      type: "component",
                      component: "Text",
                      component_type: "qdm",
                      name: "Text",
                      id: "BloHR",
                      attr: null,
                      properties: {
                        name: "Admin",
                      },
                      inlineStyles: {
                        color: "#9297a5",
                      },
                    },
                  ],
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: 2,
              },
              inlineStyles: {
                padding: "10px",
                borderColor: "#e0e0e0d6",
                borderWidth: "1px",
                borderStyle: "solid",
                backgroundColor: "#f5f5f5",
              },
            },
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "8xqXl",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "ZYc5O",
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Card",
                      component_type: "qdm",
                      name: "Card",
                      id: "d5ZSf",
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "hNxW4",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "0aTLD",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "6",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                              },
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "gb1vO",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: "MvuN1",
                                      attr: null,
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://image.freepik.com/free-vector/healthcare-logo_10250-3453.jpg",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        margin: "0px",
                                      },
                                    },
                                  ],
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "Adn6P",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "a50gt",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "hodU5",
                                          attr: null,
                                          properties: {
                                            name: "Vasan Dental Clinic",
                                          },
                                          inlineStyles: {
                                            marginRight: "10px",
                                            fontSize: "1rem",
                                          },
                                        },
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "etOE8",
                                          attr: null,
                                          properties: {
                                            name: "ACTIVE",
                                          },
                                          inlineStyles: {
                                            color: "#31b198",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "Hkm1P",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Chip",
                                          component_type: "qdm",
                                          name: "Chip",
                                          id: "DwrAg",
                                          attr: null,
                                          properties: {
                                            variant: "circle",
                                            name: "Chip",
                                          },
                                          inlineStyles: {
                                            margin: "0px",
                                            paddingTop: "5px",
                                            paddingLeft: "10px",
                                            paddingBottom: "5px",
                                            paddingRight: "10px",
                                            color: "#9297a5",
                                            fontSize: "14px",
                                            backgroundColor: "#f4f4f5",
                                            borderColor: "#f4f4f5",
                                            borderRadius: "4px",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "1",
                                  },
                                  inlineStyles: {},
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "39lwz",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "6",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {
                                textAlign: "right",
                              },
                              child: [
                                {
                                  type: "component",
                                  component: "Button",
                                  component_type: "qdm",
                                  name: "Button",
                                  id: "AJjUF",
                                  attr: null,
                                  properties: {
                                    type: "button",
                                    color: "primary",
                                    size: "medium",
                                    variant: "text",
                                    name: "DEACTIVATE",
                                  },
                                  inlineStyles: {
                                    borderColor: "#009490",
                                    color: "#009490",
                                    marginRight: "12px",
                                    borderRadius: "8px",
                                    marginBottom: "10px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Button",
                                  component_type: "qdm",
                                  name: "Button",
                                  id: "sviqy",
                                  attr: null,
                                  properties: {
                                    type: "button",
                                    color: "primary",
                                    size: "medium",
                                    variant: "outlined",
                                    name: "Edit Details",
                                  },
                                  inlineStyles: {
                                    backgroundColor: "#009490",
                                    borderColor: "#009490",
                                    borderRadius: "8px",
                                    marginRight: "12px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Button",
                                  component_type: "qdm",
                                  name: "Button",
                                  id: "6OveQ",
                                  attr: null,
                                  properties: {
                                    type: "button",
                                    color: "primary",
                                    size: "medium",
                                    variant: "outlined",
                                    name: "Add Branch",
                                  },
                                  inlineStyles: {
                                    backgroundColor: "#009490",
                                    borderColor: "#009490",
                                    borderRadius: "8px",
                                  },
                                },
                              ],
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: 2,
                          },
                          inlineStyles: {
                            padding: "10px",
                          },
                        },
                        {
                          type: "component",
                          component: "Divider",
                          component_type: "qdm",
                          name: "Divider",
                          id: "alzMt",
                          attr: null,
                          properties: {
                            orientation: "horizontal",
                            variant: "fullWidth",
                          },
                          inlineStyles: {
                            backgroundColor: "#f4f4f5",
                          },
                        },
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "eLu6i",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "ULyiv",
                              attr: null,
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "pu9OJ",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: "qOrmZ",
                                      attr: null,
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://www.pngkey.com/png/detail/113-1132660_free-icons-png-home-hospital-icon.png",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        width: "24px",
                                        height: "24px",
                                        margin: "0px",
                                        backgroundColor: "#f5f4f5",
                                        borderColor: "#f5f4f5",
                                        borderWidth: "1px",
                                        borderStyle: "",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingTop: "10px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "Ifjow",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "qfFC6",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "b07b9dd6-27a5-4748-8f57-e86ca4785a83",
                                          attr: null,
                                          properties: {
                                            name: "NAME",
                                          },
                                          inlineStyles: {
                                            color: "#9297a5",
                                            fontSize: "13px",
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "79lpU",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "H6",
                                          component_type: "qdm",
                                          name: "H6",
                                          id: "XL6kc",
                                          attr: null,
                                          properties: {
                                            name: "Vasan Dental Clinic",
                                          },
                                          inlineStyles: {
                                            fontSize: "14px",
                                            fontWeight: "400",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingLeft: "12px",
                                  },
                                },
                              ],
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "6",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {
                                display: "inline-flex",
                              },
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "ioJ1S",
                              attr: null,
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "WEuOy",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: "pJTW3",
                                      attr: null,
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://www.pngkey.com/png/detail/113-1132660_free-icons-png-home-hospital-icon.png",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        width: "24px",
                                        height: "24px",
                                        margin: "0px",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingTop: "10px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "v2YJf",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "JDpZY",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "FrXTp",
                                          attr: null,
                                          properties: {
                                            name: "BUSINESS REGISTRATION NUMBER",
                                          },
                                          inlineStyles: {
                                            color: "#9297a5",
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "8qrmt",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "DG5g3",
                                          attr: null,
                                          properties: {
                                            name: "vase312432",
                                          },
                                          inlineStyles: {
                                            fontSize: "14px",
                                            fontWeight: "400",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingLeft: "12px",
                                  },
                                },
                              ],
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "6",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {
                                display: "inline-flex",
                              },
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "jJqVp",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "6",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {
                                display: "inline-flex",
                              },
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "A2Ji5",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: "IMLBI",
                                      attr: null,
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://www.pngkey.com/png/detail/113-1132660_free-icons-png-home-hospital-icon.png",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        width: "24px",
                                        height: "24px",
                                        margin: "0px",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingTop: "10px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "d4ya8",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "NkdcQ",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "ec8550c5-0898-48d5-a71e-87fcbdc5279d",
                                          attr: null,
                                          properties: {
                                            name: "PREMISE REGISTRATION NUMBER",
                                          },
                                          inlineStyles: {
                                            color: "#9297a5",
                                            fontSize: "13px",
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "hwYQv",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "baa12a36-7576-459a-930e-a675c6089885",
                                          attr: null,
                                          properties: {
                                            name: "vadfsd234234 342432",
                                          },
                                          inlineStyles: {},
                                        },
                                      ],
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingLeft: "12px",
                                  },
                                },
                              ],
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: 2,
                          },
                          inlineStyles: {
                            padding: "20px",
                          },
                        },
                        {
                          type: "component",
                          component: "Divider",
                          component_type: "qdm",
                          name: "Divider",
                          id: "xrpFJ",
                          attr: null,
                          properties: {
                            orientation: "horizontal",
                            variant: "fullWidth",
                          },
                          inlineStyles: {
                            backgroundColor: "#f4f4f5",
                          },
                        },
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "p4jbu",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "NuAVW",
                              attr: null,
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "cweTZ",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: "p2l15",
                                      attr: null,
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR10dOvS9dFlU8SQnJbpmzgHQxcEtmsgO6GwA&usqp=CAU",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        width: "20px",
                                        height: "20px",
                                        margin: "0px",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "22",
                                  },
                                  inlineStyles: {
                                    width: "",
                                    height: "",
                                    paddingTop: "10px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "btDpk",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "K3WCT",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "32qLl",
                                          attr: null,
                                          properties: {
                                            name: "SERVICE SUPERVISOR NAME",
                                          },
                                          inlineStyles: {
                                            fontSize: "13px",
                                            color: "#9297a5",
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "2Pag1",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "Mn61v",
                                          attr: null,
                                          properties: {
                                            name: "Not Mapped",
                                          },
                                          inlineStyles: {
                                            fontSize: "14px",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingLeft: "12px",
                                  },
                                },
                              ],
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: 12,
                                xs: 12,
                                md: 12,
                                sm: 12,
                              },
                              inlineStyles: {
                                display: "inline-flex",
                              },
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: 2,
                          },
                          inlineStyles: {
                            padding: "20px",
                          },
                        },
                        {
                          type: "component",
                          component: "Divider",
                          component_type: "qdm",
                          name: "Divider",
                          id: "fyRx7",
                          attr: null,
                          properties: {
                            orientation: "horizontal",
                            variant: "fullWidth",
                          },
                          inlineStyles: {
                            backgroundColor: "#f4f4f5",
                          },
                        },
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "9p9mJ",
                          attr: null,
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: "2",
                          },
                          inlineStyles: {
                            padding: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "vd79Z",
                              attr: null,
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "HLN1a",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: "tZqYN",
                                      attr: null,
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://png2.cleanpng.com/sh/956d42ef042c52c10da111ccb744ba99/L0KzQYm3VsIxN5d4fpH0aYP2gLBuTfNwdaF6jNd7LXnmf7B6TgBpgaRue9tqbj3wdbXwgBlvbV5ph9V9b4KwfbL6i702amNmfqdtNnW2QoG6WL4yO2c7SKs5NEG4Qoq8VMIyOGMAS6I8LoDxd1==/kisspng-computer-icons-physician-medicine-doctor-mask-5b2af5d6e32038.1366090415295421029303.png",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor: "#fff",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingTop: "5px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "SmulL",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "zPuyf",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "wpmmt",
                                          attr: null,
                                          properties: {
                                            name: "PRODUCTS",
                                          },
                                          inlineStyles: {
                                            color: "#9297a5",
                                            fontSize: "13px",
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "U9Cu8",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Chip",
                                          component_type: "qdm",
                                          name: "Chip",
                                          id: "28oLZ",
                                          attr: null,
                                          properties: {
                                            variant: "circle",
                                            name: "No products mapped to you",
                                          },
                                          inlineStyles: {
                                            margin: "0px",
                                            borderRadius: "4px",
                                            backgroundColor: "#e0e0e0",
                                            borderColor: "#e0e0e0",
                                            color: "#000",
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            paddingLeft: "10px",
                                            paddingRight: "10px",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingLeft: "12px",
                                  },
                                },
                              ],
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: 12,
                                xs: 12,
                                md: 12,
                                sm: 12,
                              },
                              inlineStyles: {
                                display: "inline-flex",
                              },
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Divider",
                          component_type: "qdm",
                          name: "Divider",
                          id: "ICHY1",
                          attr: null,
                          properties: {
                            orientation: "horizontal",
                            variant: "fullWidth",
                          },
                          inlineStyles: {
                            backgroundColor: "#f4f4f5",
                          },
                        },
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "bnCQ0",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "OxrQb",
                              attr: null,
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "6U2Of",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: "63mZ1",
                                      attr: null,
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://www.pngkey.com/png/detail/113-1132660_free-icons-png-home-hospital-icon.png",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor: "#fff",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingTop: "5px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "wz0h7",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "JUzP9",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "mblVa",
                                          attr: null,
                                          properties: {
                                            name: "REMARKS",
                                          },
                                          inlineStyles: {
                                            color: "#9297a5",
                                            fontSize: "13px",
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "BNoNy",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "xwXb3",
                                          attr: null,
                                          properties: {
                                            name: "N/A",
                                          },
                                          inlineStyles: {
                                            fontSize: "14px",
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingLeft: "12px",
                                  },
                                },
                              ],
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: 12,
                                xs: 12,
                                md: 12,
                                sm: 12,
                              },
                              inlineStyles: {
                                display: "inline-flex",
                              },
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: 2,
                          },
                          inlineStyles: {
                            padding: "20px",
                          },
                        },
                        {
                          type: "component",
                          component: "Divider",
                          component_type: "qdm",
                          name: "Divider",
                          id: "9kqxy",
                          attr: null,
                          properties: {
                            orientation: "horizontal",
                            variant: "fullWidth",
                          },
                          inlineStyles: {
                            backgroundColor: "#f4f4f5",
                          },
                        },
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "KYnTD",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "H2X7j",
                              attr: null,
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "6egG0",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: "V5VTV",
                                      attr: null,
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://cdn4.iconfinder.com/data/icons/medical-business/512/medical_help-512.png",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor: "#fff",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {},
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: "B56Lq",
                                  attr: null,
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "XsNds",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: "xdPtQ",
                                          attr: null,
                                          properties: {
                                            name: "BRANCHES",
                                          },
                                          inlineStyles: {
                                            color: "#9297a5",
                                          },
                                        },
                                      ],
                                      properties: {
                                        name: "qdm-col-12",
                                        alignItems: "stretch",
                                        direction: "row",
                                        justify: "flex-start",
                                        textAlign: "left",
                                        lg: 12,
                                        xs: 12,
                                        md: 12,
                                        sm: 12,
                                      },
                                      inlineStyles: {
                                        paddingBottom: "",
                                        marginBottom: "7px",
                                      },
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: "FmP0V",
                                      attr: null,
                                      child: [
                                        {
                                          type: "component",
                                          component: "Avatar",
                                          component_type: "qdm",
                                          name: "Avatar",
                                          id: "1DhWA",
                                          attr: null,
                                          properties: {
                                            variant: "circle",
                                            letter: "V",
                                            src: "",
                                            alt: "Image",
                                          },
                                          inlineStyles: {
                                            width: "40px",
                                            height: "40px",
                                            margin: "0px",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            backgroundColor: "#d1d8e0",
                                            color: "#fff",
                                          },
                                        },
                                        {
                                          type: "component",
                                          component: "Button",
                                          component_type: "qdm",
                                          name: "Button",
                                          id: "9wSE1",
                                          attr: null,
                                          properties: {
                                            type: "button",
                                            color: "default",
                                            size: "small",
                                            variant: "text",
                                            name: "VIEW DETAILS",
                                          },
                                          inlineStyles: {
                                            color: "#f27d35",
                                            fontWeight: "600",
                                            fontSize: "12px",
                                          },
                                        },
                                      ],
                                      properties: {
                                        name: "qdm-col-12",
                                        alignItems: "stretch",
                                        direction: "row",
                                        justify: "flex-start",
                                        textAlign: "left",
                                        lg: 12,
                                        xs: 12,
                                        md: 12,
                                        sm: 12,
                                      },
                                      inlineStyles: {
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: "",
                                  },
                                  inlineStyles: {
                                    paddingLeft: "12px",
                                  },
                                },
                              ],
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: 12,
                                xs: 12,
                                md: 12,
                                sm: 12,
                              },
                              inlineStyles: {
                                display: "inline-flex",
                              },
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: "2",
                          },
                          inlineStyles: {
                            padding: "20px",
                          },
                        },
                      ],
                    },
                  ],
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: 12,
                    xs: 12,
                    md: 12,
                    sm: 12,
                  },
                  inlineStyles: {
                    padding: "",
                  },
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: 2,
              },
              inlineStyles: {
                padding: "20px",
              },
            },
          ],
        },
      ],
    },
  },
  {
    id: "Y9YDs",
    pathId: "X2GRk",
    arrowLink: [],
    name: "Add Branch",
    description: "Add Branch Screen",
    path: "/addBranch",
    render: {
      component: "div",
      component_type: "qdm",
      child: [
        {
          type: "component",
          component: "Container",
          component_type: "qdm",
          name: "Container",
          id: "6JhuQ",
          attr: null,
          child: [
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "EUG0K",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "tFDsD",
                  attr: null,
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "6",
                    xs: "6",
                    md: "6",
                    sm: "6",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  },
                  child: [
                    {
                      type: "component",
                      component: "Avatar",
                      component_type: "qdm",
                      name: "Avatar",
                      id: "XAwNl",
                      attr: null,
                      properties: {
                        variant: "circle",
                        letter: "Avatar",
                        src: "https://www.pinclipart.com/picdir/middle/544-5440422_back-arrow-icon-transparent-png-clipart-free-download.png",
                        alt: "Image",
                      },
                      inlineStyles: {
                        margin: "0px",
                        marginRight: "12px",
                        width: "24px",
                        height: "24px",
                        backgroundColor: "#f5f5f5",
                      },
                    },
                    {
                      type: "component",
                      component: "Text",
                      component_type: "qdm",
                      name: "Text",
                      id: "hlbeE",
                      attr: null,
                      properties: {
                        name: "Add Branch",
                      },
                      inlineStyles: {
                        fontSize: "20px",
                        fontWeight: "500",
                      },
                    },
                  ],
                },
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "IidNd",
                  attr: null,
                  properties: {
                    name: "qdm-col-12",
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    textAlign: "left",
                    lg: "6",
                    xs: "6",
                    md: "6",
                    sm: "6",
                  },
                  inlineStyles: {
                    textAlign: "right",
                  },
                  child: [
                    {
                      type: "component",
                      component: "H6",
                      component_type: "qdm",
                      name: "H6",
                      id: "cwCLn",
                      attr: null,
                      properties: {
                        name: "Ajay Crayond",
                      },
                      inlineStyles: {
                        fontSize: "14px",
                        fontWeight: "400",
                      },
                    },
                    {
                      type: "component",
                      component: "Text",
                      component_type: "qdm",
                      name: "Text",
                      id: "cD7Mn",
                      attr: null,
                      properties: {
                        name: "Admin",
                      },
                      inlineStyles: {
                        color: "#9297a5",
                        fontSize: "13px",
                      },
                    },
                  ],
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: 2,
              },
              inlineStyles: {
                borderColor: "#e0e0e0d6",
                borderWidth: "1px",
                borderStyle: "solid",
                backgroundColor: "#f5f5f5",
                padding: "10px",
              },
            },
            {
              type: "component",
              component: "Row",
              component_type: "qdm",
              name: "Row",
              id: "dXLZP",
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Col",
                  component_type: "qdm",
                  name: "Col",
                  id: "0RCiZ",
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Card",
                      component_type: "qdm",
                      name: "Card",
                      id: "z4HUK",
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "woVFo",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Upload",
                              component_type: "qdm",
                              name: "Upload",
                              id: "GF08J",
                              attr: null,
                              properties: {
                                fileList: [],
                              },
                              inlineStyles: {
                                backgroundColor: "#f4f4f5",
                                borderRadius: "",
                                borderWidth: "1px",
                                borderStyle: "solid",
                                borderColor: "#f4f4f5",
                              },
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: "4",
                          },
                          inlineStyles: {
                            padding: "20px",
                          },
                        },
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "adccZ",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "uCIQY",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "ZD9vV",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "NAME",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "K2sAk",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "LtHqo",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "BUSINESS REGISTRATION NUMBER",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "BUSINESS REGISTRATION NUMBER",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "56mso",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "WOCxl",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "PREMISE REGISTRATION NUMBER",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "YlIm8",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {
                                margin: "",
                              },
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "KxSgD",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "DATE OF INCORPORATION",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "VWNWZ",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "z0sYt",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "WEBSITE",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "S1NXL",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "Select",
                                  component_type: "qdm",
                                  name: "Select",
                                  id: "CyCtR",
                                  attr: null,
                                  properties: {
                                    disabled: false,
                                    size: "medium",
                                    helperTextType: "error",
                                    label: "CATEGORY",
                                    variant: "outlined",
                                  },
                                  inlineStyles: {},
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "ZdfLX",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "BOYQ4",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "PRIMARY EMAIL ADDRESS",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "oEulC",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "kYuYs",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "PRIMARY PHONE NUMBER",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "wFlhn",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "lYlm3",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "ADDRESS LINE 1",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "ABehJ",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "0OQOR",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "ADDRESS LINE 2",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "hNUHN",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "Ag6eh",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "CITY",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "EdEl3",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "9ewNz",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "STATE",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "IeYhq",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "Wkw7r",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: " COUNTRY",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "WJub2",
                              attr: null,
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "4",
                                xs: 12,
                                md: "6",
                                sm: 12,
                              },
                              inlineStyles: {},
                              child: [
                                {
                                  type: "component",
                                  component: "TextInput",
                                  component_type: "qdm",
                                  name: "TextInput",
                                  id: "d2LrQ",
                                  attr: null,
                                  properties: {
                                    type: "text",
                                    name: "text",
                                    size: "medium",
                                    variant: "outlined",
                                    helperTextType: "error",
                                    label: "POSTAL CODE",
                                    autoFocus: false,
                                  },
                                  inlineStyles: {
                                    margin: "0px",
                                  },
                                },
                              ],
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: "4",
                          },
                          inlineStyles: {
                            padding: "10px",
                          },
                        },
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: "qc1Ui",
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: "ISmab",
                              attr: null,
                              child: [
                                {
                                  type: "component",
                                  component: "Button",
                                  component_type: "qdm",
                                  name: "Button",
                                  id: "cPaB0",
                                  attr: null,
                                  properties: {
                                    type: "button",
                                    color: "primary",
                                    size: "medium",
                                    variant: "text",
                                    name: "CANCEL",
                                  },
                                  inlineStyles: {
                                    marginRight: "14px",
                                    color: "#009490",
                                    borderColor: "#009490",
                                    borderRadius: "8px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Button",
                                  component_type: "qdm",
                                  name: "Button",
                                  id: "3KRMh",
                                  attr: null,
                                  properties: {
                                    type: "button",
                                    color: "primary",
                                    size: "medium",
                                    variant: "outlined",
                                    name: "ADD",
                                  },
                                  inlineStyles: {
                                    backgroundColor: "#009490",
                                    borderColor: "#009490",
                                    borderRadius: "8px",
                                  },
                                },
                              ],
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: 12,
                                xs: 12,
                                md: 12,
                                sm: 12,
                              },
                              inlineStyles: {
                                textAlign: "right",
                              },
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: "4",
                          },
                          inlineStyles: {
                            padding: "10px",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
              properties: {
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                spacing: 2,
              },
              inlineStyles: {
                padding: "20px",
              },
            },
          ],
          properties: {
            name: "container",
            fluid: true,
          },
          inlineStyles: {
            height: "100%",
            backgroundColor: "#f5f4f5",
            padding: "0px",
          },
        },
      ],
    },
  },
];

//mock data for rendering html
export const AllScreenHtml = [
  {
    id: "U2ZYK",
    pathId: "lw8Oo",
    arrowLink: [],
    name: "Login",
    description: "Login screen main landing page",
    path: "/",
    isHome: true,
    css: "https://firebasestorage.googleapis.com/v0/b/offlineoffers.appspot.com/o/style_avfnb4.css?alt=media&token=b0731f7b-a5b7-4323-90e0-4cda5c47be1f",
    render: {
      component: "div",
      component_type: "qdm",
      child: [
        {
          type: "component",
          component: "div",
          component_type: "html",
          name: "div",
          id: "HvQCF",
          child: [
            {
              type: "component",
              component: "input",
              component_type: "html",
              name: "input",
              id: "bjhMQ",
              child: [],
              properties: {
                type: "hidden",
                value: "csk-auction-login",
              },
              inlineStyles: {},
              attributes: {
                id: "anPageName",
                name: "page",
              },
            },
            {
              type: "component",
              component: "div",
              component_type: "html",
              name: "div",
              id: "SMs0V",
              child: [
                {
                  type: "component",
                  component: "form",
                  component_type: "html",
                  name: "form",
                  id: "htsia",
                  child: [
                    {
                      type: "component",
                      component: "div",
                      component_type: "html",
                      name: "div",
                      id: "efdkQ",
                      child: [
                        {
                          type: "component",
                          component: "img",
                          component_type: "html",
                          name: "img",
                          id: "vRXVj",
                          child: [],
                          properties: {
                            src: "http://res.cloudinary.com/hackon/image/upload/v1631684760/hackonhari-checklist/image-12_1x_wyyprz.png",
                          },
                          inlineStyles: {},
                          attributes: {
                            class: "image-1",
                          },
                        },
                        {
                          type: "component",
                          component: "img",
                          component_type: "html",
                          name: "img",
                          id: "4X3HA",
                          child: [],
                          properties: {
                            src: "http://res.cloudinary.com/hackon/image/upload/v1631684760/hackonhari-checklist/image-12_1x_wyyprz.png",
                          },
                          inlineStyles: {},
                          attributes: {
                            class: "image-1",
                          },
                        },
                        {
                          type: "component",
                          component: "div",
                          component_type: "html",
                          name: "div",
                          id: "CaNKt",
                          child: [
                            {
                              type: "component",
                              component: "img",
                              component_type: "html",
                              name: "img",
                              id: "7Oz2n",
                              child: [],
                              properties: {
                                src: "http://res.cloudinary.com/hackon/image/upload/v1631684770/hackonhari-checklist/path-239_1x_n3idom.png",
                              },
                              inlineStyles: {},
                              attributes: {
                                class: "path-239",
                              },
                            },
                          ],
                          properties: {},
                          inlineStyles: {},
                          attributes: {
                            class: "group-2891",
                          },
                        },
                        {
                          type: "component",
                          component: "img",
                          component_type: "html",
                          name: "img",
                          id: "brDWE",
                          child: [],
                          properties: {
                            src: "http://res.cloudinary.com/hackon/image/upload/v1631684765/hackonhari-checklist/image-15_1x_d5an9x.png",
                          },
                          inlineStyles: {},
                          attributes: {
                            class: "image-1",
                          },
                        },
                        {
                          type: "component",
                          component: "div",
                          component_type: "html",
                          name: "div",
                          id: "2uQhw",
                          child: [],
                          properties: {},
                          inlineStyles: {},
                          attributes: {
                            class: "image-16",
                          },
                        },
                        {
                          type: "component",
                          component: "div",
                          component_type: "html",
                          name: "div",
                          id: "CXo3Z",
                          child: [],
                          properties: {},
                          inlineStyles: {},
                          attributes: {
                            class: "rectangle-488",
                          },
                        },
                        {
                          type: "component",
                          component: "img",
                          component_type: "html",
                          name: "img",
                          id: "PWmTX",
                          child: [],
                          properties: {
                            src: "http://res.cloudinary.com/hackon/image/upload/v1631684771/hackonhari-checklist/path-240_1x_uffvjk.png",
                          },
                          inlineStyles: {},
                          attributes: {
                            class: "path-240",
                          },
                        },
                        {
                          type: "component",
                          component: "input",
                          component_type: "html",
                          name: "input",
                          id: "XJH3r",
                          child: [],
                          properties: {
                            placeholder: "Email ID",
                            type: "email",
                          },
                          inlineStyles: {},
                          attributes: {
                            class: "email-id",
                            name: "email-id7",
                            required: "",
                          },
                        },
                        {
                          type: "component",
                          component: "a",
                          component_type: "html",
                          name: "a",
                          id: "Ga1Iv",
                          child: [
                            {
                              type: "component",
                              component: "div",
                              component_type: "html",
                              name: "div",
                              id: "eI5Ga",
                              child: [
                                {
                                  type: "component",
                                  component: "div",
                                  component_type: "html",
                                  name: "div",
                                  id: "MkYSS",
                                  child: [],
                                  properties: {
                                    name: "SIGN IN",
                                  },
                                  inlineStyles: {},
                                  attributes: {
                                    class: "sign-in",
                                  },
                                },
                              ],
                              properties: {},
                              inlineStyles: {},
                              attributes: {
                                class: "group-139",
                              },
                            },
                          ],
                          properties: {
                            href: "javascript:SubmitForm('form1')",
                          },
                          inlineStyles: {},
                          attributes: {},
                        },
                        {
                          type: "component",
                          component: "div",
                          component_type: "html",
                          name: "div",
                          id: "rmwoF",
                          child: [],
                          properties: {},
                          inlineStyles: {},
                          attributes: {
                            class: "rectangle-78",
                          },
                        },
                        {
                          type: "component",
                          component: "input",
                          component_type: "html",
                          name: "input",
                          id: "2XjNF",
                          child: [],
                          properties: {
                            placeholder: "Password",
                            type: "password",
                          },
                          inlineStyles: {},
                          attributes: {
                            class: "password",
                            name: "password10",
                            required: "",
                          },
                        },
                        {
                          type: "component",
                          component: "img",
                          component_type: "html",
                          name: "img",
                          id: "v6WA1",
                          child: [],
                          properties: {
                            src: "http://res.cloudinary.com/hackon/image/upload/v1631684736/hackonhari-checklist/icons8-eye_1x_i3s10j.png",
                          },
                          inlineStyles: {},
                          attributes: {
                            class: "icons8-eye",
                          },
                        },
                        {
                          type: "component",
                          component: "img",
                          component_type: "html",
                          name: "img",
                          id: "wNngt",
                          child: [],
                          properties: {
                            src: "http://res.cloudinary.com/hackon/image/upload/v1631684767/hackonhari-checklist/intersection-13_1x_ra3dhz.png",
                          },
                          inlineStyles: {},
                          attributes: {
                            class: "intersection-13",
                          },
                        },
                      ],
                      properties: {},
                      inlineStyles: {},
                      attributes: {
                        class: "overlap-group",
                      },
                    },
                  ],
                  properties: {},
                  inlineStyles: {},
                  attributes: {
                    class: "csk-auction-login screen",
                    name: "form1",
                    action: "form1",
                    method: "post",
                  },
                },
              ],
              properties: {},
              inlineStyles: {},
              attributes: {
                class: "container-center-horizontal",
              },
            },
          ],
          properties: {},
          inlineStyles: {
            margin: "0",
            background: "#f5f5f5",
          },
          attributes: {},
        },
      ],
    },
  },
];

export const mainMenuList = [
  {
    name: "Screens",
    id: 0,
    icon: "FlipToFront",
  },
  {
    name: "Components",
    id: 1,
    icon: "OpenInBrowser",
  },
  {
    name: "Screen Tree",
    id: 2,
    icon: "OpenInBrowser",
  },
];

// template layout JSON
export const templates = [
  {
    name: "Login 1",
    type: "screen",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-27-at-2.56.21-AM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Avatar",
                  component_type: "qdm",
                  name: "Avatar",
                  id: makeid(),
                  attr: null,
                  properties: {
                    variant: "circle",
                    letter: "Avatar",
                    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaYJedNSI9VRBJHtu9Ap70kCbn_phlUrz6GaStb9XOsriIg7nV8PTwEUMNR3MNog_MKUM&usqp=CAU",
                    alt: "Image",
                  },
                  inlineStyles: {
                    backgroundColor: "#fff",
                    borderRadius: "0px",
                    margin: "0px",
                    height: "40px",
                    width: "120px",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            padding: "20px",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: "6",
                sm: 12,
              },
              inlineStyles: {
                textAlign: "center",
              },
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Avatar",
                      component_type: "qdm",
                      name: "Avatar",
                      id: makeid(),
                      attr: null,
                      properties: {
                        variant: "circle",
                        letter: "Avatar",
                        src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaYJedNSI9VRBJHtu9Ap70kCbn_phlUrz6GaStb9XOsriIg7nV8PTwEUMNR3MNog_MKUM&usqp=CAU",
                        alt: "Image",
                      },
                      inlineStyles: {
                        margin: "auto",
                        borderRadius: "0px",
                        backgroundColor: "#fff",
                        width: "312px",
                        height: "312px",
                      },
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    display: "",
                  },
                },
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",
                          id: makeid(),
                          attr: null,
                          properties: {
                            name: "Leveraging the power of a connected community, towards the empowerment of health, wellness and care for individuals and families.",
                          },
                          inlineStyles: {
                            textAlign: "center",
                          },
                        },
                        {
                          type: "component",
                          component: "H6",
                          component_type: "qdm",
                          name: "H6",
                          id: makeid(),
                          attr: null,
                          properties: {
                            name: "Description content",
                          },
                          inlineStyles: {
                            fontSize: "1rem",
                            color: "#363a57",
                            marginTop: "14px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        textAlign: "center",
                      },
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    padding: "24px",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: "6",
                sm: 12,
              },
              inlineStyles: {
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "H6",
                          component_type: "qdm",
                          name: "H6",
                          id: makeid(),
                          attr: null,
                          properties: {
                            name: "Welcome Back",
                          },
                          inlineStyles: {
                            color: "#363a57",
                            fontSize: "1.5rem",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        textAlign: "center",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",
                          id: makeid(),
                          attr: null,
                          properties: {
                            name: "Enter your credentials to proceed",
                          },
                          inlineStyles: {
                            color: "#9297a5",
                            fontSize: "1rem",
                            marginBottom: "",
                            paddingBottom: "",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        textAlign: "center",
                        marginBottom: "20px",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "TextInput",
                          component_type: "qdm",
                          name: "TextInput",
                          id: makeid(),
                          attr: null,
                          properties: {
                            type: "email",
                            name: "text",
                            size: "medium",
                            variant: "outlined",
                            helperTextType: "error",
                            label: "Email Address",
                            autoFocus: false,
                          },
                          inlineStyles: {},
                        },
                        {
                          type: "component",
                          component: "TextInput",
                          component_type: "qdm",
                          name: "TextInput",
                          id: makeid(),
                          attr: null,
                          properties: {
                            type: "text",
                            name: "text",
                            size: "medium",
                            variant: "outlined",
                            helperTextType: "error",
                            label: "Password",
                            autoFocus: false,
                          },
                          inlineStyles: {},
                        },
                        {
                          type: "component",
                          component: "Button",
                          component_type: "qdm",
                          name: "Button",
                          id: makeid(),
                          attr: null,
                          properties: {
                            type: "submit",
                            color: "secondary",
                            size: "medium",
                            variant: "outlined",
                            name: "Sign In",
                          },
                          inlineStyles: {
                            width: "100%",
                            backgroundColor: "#009490",
                            borderColor: "#009490",
                            borderRadius: "8px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "12",
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {},
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    textAlign: "",
                    padding: "40px",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: "0",
          },
          inlineStyles: {
            padding: "20px",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: false,
      },
      inlineStyles: {
        backgroundColor: "#fff",
        height: "100vh",
      },
    },
  },
  {
    name: "Login 2",
    type: "screen",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-27-at-2.59.28-AM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        height: "100vh",
        backgroundColor: "#ebebeb",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      child: [
        {
          type: "component",
          component: "Card",
          component_type: "qdm",
          name: "Card",
          id: makeid(),
          properties: {
            children: "Card",
          },
          inlineStyles: {
            width: "300px",
          },
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      child: [
                        {
                          type: "component",
                          component: "Avatar",
                          component_type: "qdm",
                          name: "Avatar",
                          id: makeid(),
                          properties: {
                            variant: "circle",
                            letter: "Avatar",
                            src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaYJedNSI9VRBJHtu9Ap70kCbn_phlUrz6GaStb9XOsriIg7nV8PTwEUMNR3MNog_MKUM&usqp=CAU",
                            alt: "Image",
                          },
                          inlineStyles: {
                            backgroundColor: "#fff",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",
                          id: makeid(),
                          properties: {
                            name: "Project Name",
                          },
                          inlineStyles: {
                            fontSize: "16px",
                          },
                          customAttr: ["children"],
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    },
                  ],
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "flex-start",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {},
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",
                  id: makeid(),
                  properties: {
                    type: "text",
                    name: "text",
                    size: "medium",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "User name ",
                    autoFocus: false,
                    autoComplete: "off",
                  },
                  inlineStyles: {},
                },
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",
                  id: makeid(),
                  properties: {
                    type: "text",
                    name: "text",
                    size: "medium",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Password",
                    autoFocus: false,
                    autoComplete: "off",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginTop: "14px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Button",
                  component_type: "qdm",
                  name: "Button",
                  id: makeid(),
                  properties: {
                    type: "button",
                    color: "primary",
                    size: "medium",
                    variant: "outlined",
                    name: "Login",
                  },
                  inlineStyles: {
                    width: "100%",
                    backgroundColor: "#45bf84",
                    borderColor: "#45bf84",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
          ],
        },
      ],
    },
  },
  {
    name: "Layout 1",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.26.43-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",
                  id: makeid(),
                  properties: {
                    name: "Header",
                  },
                  inlineStyles: {
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "#fff",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#007aff",
                height: "55px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            },
          ],
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "4",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#ffffff",
                color: "",
                padding: "20px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  properties: {
                    name: "Side bar",
                  },
                  inlineStyles: {
                    color: "#000",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "8",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#e8e8e8",
                padding: "20px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  properties: {
                    name: "Main content",
                  },
                  inlineStyles: {},
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        padding: "0px",
      },
    },
  },
  {
    name: "Layout 2",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.25.56-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Header",
                  },
                  inlineStyles: {
                    fontSize: "20px",
                    fontWeight: "500",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                height: "55px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            backgroundColor: "#ffffff",
            height: "",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Main Content ",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                padding: "20px",
              },
            },
          ],
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        backgroundColor: "#e8e8e8",
        height: "100vh",
        padding: "0px",
      },
    },
  },
  {
    name: "Layout 3",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.29.02-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Header",
                  },
                  inlineStyles: {
                    fontSize: "24px",
                    fontWeight: "500",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#ffffff",
                height: "60px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "1",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#3A4B58",
                padding: "10px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Menu",
                  },
                  inlineStyles: {
                    color: "#ffffff",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "11",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#f2f2f2",
                padding: "20px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Content",
                  },
                  inlineStyles: {},
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        padding: "0px",
        backgroundColor: "#ffffff",
      },
    },
  },
  {
    name: "Layout 4",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.27.56-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      attr: null,
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        backgroundColor: "#ffffff",
        padding: "0px",
      },
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                height: "60px",
                backgroundColor: "#3a4b58",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                color: "#ffffff",
              },
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Header",
                  },
                  inlineStyles: {
                    color: "",
                    fontSize: "22px",
                    fontWeight: "500",
                  },
                },
              ],
            },
          ],
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "3",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {},
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Side menu",
                  },
                  inlineStyles: {
                    padding: "10px",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#f5f5f5",
                padding: "20px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Content",
                  },
                  inlineStyles: {},
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "3",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {},
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Right Content",
                  },
                  inlineStyles: {
                    padding: "10px",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
    },
  },
  {
    name: "Layout 5",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-26-at-5.27.26-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "1",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#3A4B58",
                padding: "10px",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  attr: null,
                  properties: {
                    name: "Menu",
                  },
                  inlineStyles: {
                    color: "#ffffff",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "11",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#f2f2f2",
                padding: "0px",
              },
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",
                          id: makeid(),
                          attr: null,
                          properties: {
                            name: "Header",
                          },
                          inlineStyles: {
                            fontSize: "24px",
                            fontWeight: "500",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        backgroundColor: "#ffffff",
                        height: "60px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        padding: "",
                      },
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    height: "",
                  },
                },
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "H6",
                          component_type: "qdm",
                          name: "H6",
                          id: makeid(),
                          attr: null,
                          properties: {
                            name: "Content",
                          },
                          inlineStyles: {},
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        padding: "20px",
                      },
                    },
                  ],
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        padding: "0px",
        backgroundColor: "#ffffff",
      },
    },
  },
  {
    name: "Confirmation Template",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-29-at-10.54.42-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        height: "100vh",
        backgroundColor: "#ebebeb",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      child: [
        {
          type: "component",
          component: "Card",
          component_type: "qdm",
          name: "Card",
          id: makeid(),
          properties: {
            children: "Card",
          },
          inlineStyles: {
            width: "500px",
            padding: "20px",
          },
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      child: [
                        {
                          type: "component",
                          component: "Avatar",
                          component_type: "qdm",
                          name: "Avatar",
                          id: makeid(),
                          properties: {
                            variant: "circle",
                            letter: "Avatar",
                            src: "data:image/png;base64,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",
                            alt: "Image",
                          },
                          inlineStyles: {
                            backgroundColor: "#fff",
                            width: "70px",
                            height: "70px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      child: [
                        {
                          type: "component",
                          component: "H6",
                          component_type: "qdm",
                          name: "H6",
                          id: makeid(),
                          properties: {
                            name: "Success",
                          },
                          inlineStyles: {
                            fontSize: "24px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    },
                  ],
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "flex-start",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {},
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Divider",
                  component_type: "qdm",
                  name: "Divider",
                  id: makeid(),
                  properties: {
                    textWidth: 50,
                    textColor: "#000",
                    borderColor: "lightgray",
                    borderWidth: 1,
                    orientation: "horizontal",
                    variant: "fullWidth",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginTop: "14px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",
                  id: makeid(),
                  properties: {
                    name: "Check your emil for a confirmation. We'll see you soon",
                  },
                  inlineStyles: {
                    textAlign: "",
                    fontSize: "14px",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
                textAlign: "center",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Button",
                  component_type: "qdm",
                  name: "Button",
                  id: makeid(),
                  properties: {
                    type: "button",
                    variant: "outlined",
                    name: "Ok",
                  },
                  inlineStyles: {
                    width: "100px",
                    backgroundColor: "#63bc44",
                    borderColor: "#63bc44",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    fontSize: "20px",
                    fontWeight: "600",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
            },
          ],
        },
      ],
    },
  },
  {
    name: "Demographic Data",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-29-at-10.31.45-PM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",
                  id: makeid(),
                  properties: {
                    name: "Demographic Data",
                  },
                  inlineStyles: {
                    fontSize: "20px",
                    fontWeight: "500",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                height: "55px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            backgroundColor: "#ffffff",
            height: "",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Paper",
                  component_type: "qdm",
                  name: "Paper",
                  id: makeid(),
                  properties: {
                    children: "Paper",
                    variant: "elevation",
                    elevation: 1,
                  },
                  inlineStyles: {
                    backgroundColor: "#ffffff",
                    padding: "20px",
                    margin: "0px",
                  },
                  child: [
                    {
                      type: "component",
                      component: "Row",
                      component_type: "qdm",
                      name: "Row",
                      id: makeid(),
                      child: [
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: makeid(),
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",
                              id: makeid(),
                              properties: {
                                type: "text",
                                name: "text",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "User Name",
                                autoFocus: false,
                                autoComplete: "off",
                                search: false,
                                borderColor: "#9b9b9b",
                                elevation: "0",
                                placeholder: "text field",
                                size: "medium",
                              },
                              inlineStyles: {
                                marginTop: "",
                              },
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: makeid(),
                          properties: {
                            name: "Provider Gender",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TapSelect",
                              component_type: "qdm",
                              name: "TapSelect",
                              id: makeid(),
                              properties: {
                                type: "single",
                                fullWidth: false,
                                selectedBorderColor: "#1890ff",
                                selectedBackgroundColor: "#fff",
                                selectedTextColor: "#1890ff",
                                textSize: "small",
                                iconHeight: 20,
                                iconWidth: 20,
                                textColor: "#000",
                                label: "Gender",
                                options: [
                                  {
                                    value: "Male",
                                    label: "Male",
                                  },
                                  {
                                    value: "Female",
                                    label: "Female",
                                  },
                                  {
                                    value: "Others",
                                    label: "Others",
                                  },
                                ],
                                iconPosition: "left",
                              },
                              inlineStyles: {},
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: makeid(),
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",
                              id: makeid(),
                              properties: {
                                type: "text",
                                name: "text",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "Email",
                                autoFocus: false,
                                autoComplete: "off",
                                search: false,
                                borderColor: "#9b9b9b",
                                elevation: "0",
                                placeholder: "text field",
                                size: "medium",
                              },
                              inlineStyles: {},
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: makeid(),
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",
                              id: makeid(),
                              properties: {
                                type: "number",
                                name: "text",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "Mobile Number",
                                autoFocus: false,
                                autoComplete: "off",
                                search: false,
                                borderColor: "#9b9b9b",
                                elevation: "0",
                                placeholder: "text field",
                                size: "medium",
                              },
                              inlineStyles: {},
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: makeid(),
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: "6",
                            xs: 12,
                            md: "6",
                            sm: 12,
                          },
                          inlineStyles: {
                            marginBottom: "20px",
                          },
                          child: [
                            {
                              type: "component",
                              component: "TextInput",
                              component_type: "qdm",
                              name: "TextInput",
                              id: makeid(),
                              properties: {
                                type: "text",
                                name: "text",
                                variant: "outlined",
                                helperTextType: "error",
                                label: "Address",
                                autoFocus: false,
                                autoComplete: "off",
                                search: false,
                                borderColor: "#9b9b9b",
                                elevation: "0",
                                placeholder: "text field",
                                size: "medium",
                              },
                              inlineStyles: {},
                            },
                          ],
                        },
                        {
                          type: "component",
                          component: "Col",
                          component_type: "qdm",
                          name: "Col",
                          id: makeid(),
                          child: [
                            {
                              type: "component",
                              component: "Button",
                              component_type: "qdm",
                              name: "Button",
                              id: makeid(),
                              properties: {
                                type: "button",
                                variant: "text",
                                name: "Cancel",
                              },
                              inlineStyles: {
                                margin: "5px",
                              },
                            },
                            {
                              type: "component",
                              component: "Button",
                              component_type: "qdm",
                              name: "Button",
                              id: makeid(),
                              properties: {
                                type: "button",
                                variant: "outlined",
                                name: "Add",
                              },
                              inlineStyles: {
                                margin: "5px",
                                width: "100px",
                              },
                            },
                          ],
                          properties: {
                            name: "qdm-col-12",
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            textAlign: "left",
                            lg: 12,
                            xs: 12,
                            md: 12,
                            sm: 12,
                          },
                          inlineStyles: {
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                padding: "24px",
                paddingTop: "40px",
              },
            },
          ],
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        backgroundColor: "#e8e8e8",
        height: "100vh",
        padding: "0px",
      },
    },
  },
  {
    name: "Listing Layout",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-27-at-3.17.24-AM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: "6",
                md: "6",
                sm: "6",
              },
              inlineStyles: {
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              },
              child: [
                {
                  type: "component",
                  component: "Avatar",
                  component_type: "qdm",
                  name: "Avatar",
                  id: makeid(),
                  properties: {
                    variant: "circle",
                    letter: "Avatar",
                    src: "https://www.pinclipart.com/picdir/middle/544-5440422_back-arrow-icon-transparent-png-clipart-free-download.png",
                    alt: "Image",
                  },
                  inlineStyles: {
                    margin: "0px",
                    marginRight: "14px",
                    width: "20px",
                    height: "20px",
                    backgroundColor: "#f5f5f5",
                  },
                },
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",
                  id: makeid(),
                  properties: {
                    name: "Title",
                  },
                  inlineStyles: {
                    fontSize: "20px",
                    fontWeight: "500",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: "6",
                md: "6",
                sm: "6",
              },
              inlineStyles: {
                textAlign: "right",
              },
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  properties: {
                    name: "Profile name",
                  },
                  inlineStyles: {
                    fontSize: "14px",
                    fontWeight: "400",
                  },
                },
                {
                  type: "component",
                  component: "Text",
                  component_type: "qdm",
                  name: "Text",
                  id: makeid(),
                  properties: {
                    name: "Role",
                  },
                  inlineStyles: {
                    color: "#9297a5",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            padding: "10px",
            backgroundColor: "#f5f5f5",
            borderColor: "#e0e0e0d6",
            borderWidth: "1px",
            borderStyle: "solid",
            marginBottom: "",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Select",
                  component_type: "qdm",
                  name: "Select",
                  id: makeid(),
                  properties: {
                    disabled: false,
                    size: "medium",
                    helperTextType: "error",
                    label: "Search for provider Name",
                    variant: "outlined",
                  },
                  inlineStyles: {
                    width: "",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "8",
                xs: 12,
                md: "8",
                sm: 12,
              },
              inlineStyles: {},
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Button",
                  component_type: "qdm",
                  name: "Button",
                  id: makeid(),
                  properties: {
                    type: "button",
                    variant: "outlined",
                    name: "+ ADD BUTTON",
                    color: "primary",
                    size: "medium",
                  },
                  inlineStyles: {
                    backgroundColor: "",
                    borderColor: "",
                    borderRadius: "8px",
                    color: "#ffffff",
                  },
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "4",
                xs: 12,
                md: "4",
                sm: 12,
              },
              inlineStyles: {
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            paddingTop: "",
            padding: "14px",
          },
        },
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "H6",
                  component_type: "qdm",
                  name: "H6",
                  id: makeid(),
                  properties: {
                    name: "Titte",
                  },
                  inlineStyles: {},
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "List",
                  component_type: "qdm",
                  name: "List",
                  id: makeid(),
                  properties: {
                    children: "List",
                  },
                  inlineStyles: {
                    backgroundColor: "#f5f4f5",
                  },
                  child: [
                    {
                      type: "component",
                      component: "ListItem",
                      component_type: "qdm",
                      name: "ListItem",
                      id: makeid(),
                      properties: {
                        title: "Vasan Dental Clinic",
                        description: "List Item Descaription",
                        profile: "L",
                        action: "Click",
                        marginVertical: 0,
                        marginHorizontal: 0,
                        paddingVertical: 8,
                        paddingHorizontal: 16,
                      },
                      inlineStyles: {
                        backgroundColor: "#fff",
                        marginBottom: "20px",
                        borderRadius: "6px",
                        paddingTop: "14px",
                        paddingBottom: "14px",
                      },
                      child: [
                        {
                          type: "component",
                          component: "Row",
                          component_type: "qdm",
                          name: "Row",
                          id: makeid(),
                          child: [
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: makeid(),
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "9",
                                xs: "12",
                                md: "9",
                                sm: "12",
                              },
                              inlineStyles: {
                                display: "inline-flex",
                                justifyContent: "",
                                alignItems: "",
                                padding: "0px",
                                paddingTop: "",
                                paddingLeft: "",
                                paddingBottom: "",
                                paddingRight: "",
                              },
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: makeid(),
                                  child: [
                                    {
                                      type: "component",
                                      component: "Avatar",
                                      component_type: "qdm",
                                      name: "Avatar",
                                      id: makeid(),
                                      properties: {
                                        variant: "circle",
                                        letter: "Avatar",
                                        src: "https://image.freepik.com/free-vector/healthcare-logo_10250-3453.jpg",
                                        alt: "Image",
                                      },
                                      inlineStyles: {
                                        margin: "0px",
                                        marginRight: "14px",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: 2,
                                  },
                                  inlineStyles: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "0px",
                                  },
                                },
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: makeid(),
                                  child: [
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: makeid(),
                                      child: [
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: makeid(),
                                          properties: {
                                            name: "Vasan Dental Clinic",
                                          },
                                          inlineStyles: {
                                            marginRight: "10px",
                                            fontSize: "1rem",
                                          },
                                        },
                                        {
                                          type: "component",
                                          component: "Text",
                                          component_type: "qdm",
                                          name: "Text",
                                          id: makeid(),
                                          properties: {
                                            name: "• ACTIVE",
                                          },
                                          inlineStyles: {
                                            color: "#31b198",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                          },
                                        },
                                      ],
                                      properties: {
                                        name: "qdm-col-12",
                                        alignItems: "stretch",
                                        direction: "row",
                                        justify: "flex-start",
                                        textAlign: "left",
                                        lg: 12,
                                        xs: 12,
                                        md: 12,
                                        sm: 12,
                                      },
                                      inlineStyles: {
                                        padding: "0px",
                                        marginBottom: "10px",
                                      },
                                    },
                                    {
                                      type: "component",
                                      component: "Col",
                                      component_type: "qdm",
                                      name: "Col",
                                      id: makeid(),
                                      child: [
                                        {
                                          type: "component",
                                          component: "Chip",
                                          component_type: "qdm",
                                          name: "Chip",
                                          id: makeid(),
                                          properties: {
                                            variant: "circle",
                                            name: "Chip",
                                          },
                                          inlineStyles: {
                                            margin: "0px",
                                            padding: "",
                                            borderRadius: "4px",
                                            backgroundColor: "#f4f4f5",
                                            paddingTop: "2px",
                                            paddingBottom: "2px",
                                            paddingLeft: "10px",
                                            paddingRight: "10px",
                                            color: "#9297a5",
                                            fontSize: "14px",
                                            borderColor: "#f4f4f5",
                                          },
                                        },
                                      ],
                                      properties: {
                                        name: "qdm-col-12",
                                        alignItems: "stretch",
                                        direction: "row",
                                        justify: "flex-start",
                                        textAlign: "left",
                                        lg: 12,
                                        xs: 12,
                                        md: 12,
                                        sm: 12,
                                      },
                                      inlineStyles: {
                                        padding: "0px",
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            {
                              type: "component",
                              component: "Col",
                              component_type: "qdm",
                              name: "Col",
                              id: makeid(),
                              properties: {
                                name: "qdm-col-12",
                                alignItems: "stretch",
                                direction: "row",
                                justify: "flex-start",
                                textAlign: "left",
                                lg: "3",
                                xs: "12",
                                md: "3",
                                sm: "12",
                              },
                              inlineStyles: {
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              },
                              child: [
                                {
                                  type: "component",
                                  component: "Row",
                                  component_type: "qdm",
                                  name: "Row",
                                  id: makeid(),
                                  child: [
                                    {
                                      type: "component",
                                      component: "H6",
                                      component_type: "qdm",
                                      name: "H6",
                                      id: makeid(),
                                      properties: {
                                        name: "1",
                                      },
                                      inlineStyles: {},
                                    },
                                    {
                                      type: "component",
                                      component: "Text",
                                      component_type: "qdm",
                                      name: "Text",
                                      id: makeid(),
                                      properties: {
                                        name: "Branches",
                                      },
                                      inlineStyles: {
                                        color: "#9297a5",
                                      },
                                    },
                                  ],
                                  properties: {
                                    alignItems: "stretch",
                                    direction: "row",
                                    justify: "flex-start",
                                    spacing: 2,
                                  },
                                  inlineStyles: {
                                    display: "block",
                                  },
                                },
                              ],
                            },
                          ],
                          properties: {
                            alignItems: "stretch",
                            direction: "row",
                            justify: "flex-start",
                            spacing: 2,
                          },
                          inlineStyles: {
                            width: "100%",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            padding: "",
            paddingLeft: "14px",
            paddingRight: "14px",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        backgroundColor: "#F4F4F5",
        padding: "0px",
        height: "100vh",
      },
    },
  },
  {
    name: "Listing Card",
    type: "layout",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-04-27-at-3.45.11-AM.png",
    json: {
      type: "component",
      component: "Container",
      component_type: "qdm",
      name: "Container",
      id: makeid(),
      attr: null,
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          attr: null,
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "1",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#3A4B58",
                padding: "0px",
              },
              child: [
                {
                  type: "component",
                  component: "Div",
                  component_type: "qdm",
                  name: "Div",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Avatar",
                      component_type: "qdm",
                      name: "Avatar",
                      id: makeid(),
                      attr: null,
                      properties: {
                        variant: "rounded",
                        letter: "Avatar",
                        src: "https://i.pinimg.com/originals/72/a3/d9/72a3d9408d41335f39e9f014dc35cf44.jpg",
                        alt: "Image",
                      },
                      inlineStyles: {
                        width: "45px",
                        height: "45px",
                      },
                    },
                  ],
                  properties: {
                    className: "qdm",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    backgroundColor: "",
                  },
                },
                {
                  type: "component",
                  component: "Div",
                  component_type: "qdm",
                  name: "Div",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Icons",
                      component_type: "qdm",
                      name: "Icons",
                      id: makeid(),
                      attr: null,
                      properties: {
                        fontIcon: "area-chart",
                        ariaHidden: "true",
                        size: "small",
                      },
                      inlineStyles: {
                        fontSize: "26px",
                        color: "#ffffff",
                      },
                    },
                  ],
                  properties: {
                    className: "qdm",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px",
                    backgroundColor: "#2d3a43",
                  },
                },
                {
                  type: "component",
                  component: "Div",
                  component_type: "qdm",
                  name: "Div",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Icons",
                      component_type: "qdm",
                      name: "Icons",
                      id: makeid(),
                      attr: null,
                      properties: {
                        fontIcon: "asl-interpreting",
                        ariaHidden: "true",
                        size: "small",
                      },
                      inlineStyles: {
                        fontSize: "26px",
                        color: "#ffffff",
                      },
                    },
                  ],
                  properties: {
                    className: "qdm",
                  },
                  inlineStyles: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px",
                    backgroundColor: "",
                  },
                },
              ],
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              attr: null,
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "11",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                backgroundColor: "#f2f2f2",
                padding: "0px",
              },
              child: [
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Text",
                          component_type: "qdm",
                          name: "Text",
                          id: makeid(),
                          attr: null,
                          properties: {
                            name: "Header",
                          },
                          inlineStyles: {
                            fontSize: "24px",
                            fontWeight: "500",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: 12,
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {
                        backgroundColor: "#ffffff",
                        height: "60px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        padding: "",
                      },
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    height: "",
                  },
                },
                {
                  type: "component",
                  component: "Row",
                  component_type: "qdm",
                  name: "Row",
                  id: makeid(),
                  attr: null,
                  child: [
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      child: [
                        {
                          type: "component",
                          component: "Card",
                          component_type: "qdm",
                          name: "Card",
                          id: makeid(),
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "CardHeader",
                              component_type: "qdm",
                              name: "CardHeader",
                              id: makeid(),
                              attr: null,
                            },
                            {
                              type: "component",
                              component: "CardContent",
                              component_type: "qdm",
                              name: "CardContent",
                              id: makeid(),
                              attr: null,
                            },
                          ],
                          properties: {
                            children: "Card",
                          },
                          inlineStyles: {
                            marginBottom: "30px",
                          },
                        },
                      ],
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "4",
                        xs: 12,
                        md: "4",
                        sm: 12,
                      },
                      inlineStyles: {
                        padding: "",
                      },
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "4",
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {},
                      child: [
                        {
                          type: "component",
                          component: "Card",
                          component_type: "qdm",
                          name: "Card",
                          id: makeid(),
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "CardHeader",
                              component_type: "qdm",
                              name: "CardHeader",
                              id: makeid(),
                              attr: null,
                            },
                            {
                              type: "component",
                              component: "CardContent",
                              component_type: "qdm",
                              name: "CardContent",
                              id: makeid(),
                              attr: null,
                            },
                          ],
                          properties: {
                            children: "Card",
                          },
                          inlineStyles: {
                            marginBottom: "30px",
                          },
                        },
                      ],
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "4",
                        xs: 12,
                        md: 12,
                        sm: 12,
                      },
                      inlineStyles: {},
                      child: [
                        {
                          type: "component",
                          component: "Card",
                          component_type: "qdm",
                          name: "Card",
                          id: makeid(),
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "CardHeader",
                              component_type: "qdm",
                              name: "CardHeader",
                              id: makeid(),
                              attr: null,
                            },
                            {
                              type: "component",
                              component: "CardContent",
                              component_type: "qdm",
                              name: "CardContent",
                              id: makeid(),
                              attr: null,
                            },
                          ],
                          properties: {
                            children: "Card",
                          },
                          inlineStyles: {
                            marginBottom: "30px",
                          },
                        },
                      ],
                    },
                    {
                      type: "component",
                      component: "Col",
                      component_type: "qdm",
                      name: "Col",
                      id: makeid(),
                      attr: null,
                      properties: {
                        name: "qdm-col-12",
                        alignItems: "stretch",
                        direction: "row",
                        justify: "flex-start",
                        textAlign: "left",
                        lg: "4",
                        xs: 12,
                        md: "4",
                        sm: 12,
                      },
                      inlineStyles: {},
                      child: [
                        {
                          type: "component",
                          component: "Card",
                          component_type: "qdm",
                          name: "Card",
                          id: makeid(),
                          attr: null,
                          child: [
                            {
                              type: "component",
                              component: "CardHeader",
                              component_type: "qdm",
                              name: "CardHeader",
                              id: makeid(),
                              attr: null,
                            },
                            {
                              type: "component",
                              component: "CardContent",
                              component_type: "qdm",
                              name: "CardContent",
                              id: makeid(),
                              attr: null,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  properties: {
                    alignItems: "stretch",
                    direction: "row",
                    justify: "flex-start",
                    spacing: 2,
                  },
                  inlineStyles: {
                    padding: "30px",
                  },
                },
              ],
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            height: "100vh",
          },
        },
      ],
      properties: {
        name: "container",
        fluid: true,
      },
      inlineStyles: {
        padding: "0px",
        backgroundColor: "#ffffff",
      },
    },
  },
  {
    name: "Form 1",
    type: "component",
    preview_url:
      "https://www.linkpicture.com/q/Screenshot-2021-06-02-at-12.05.06-PM.png",
    json: {
      type: "component",
      component: "Form",
      component_type: "qdm",
      name: "Form",
      id: makeid(),
      child: [
        {
          type: "component",
          component: "Row",
          component_type: "qdm",
          name: "Row",
          id: makeid(),
          child: [
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",
                  id: makeid(),
                  properties: {
                    type: "text",
                    name: "text",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Name",
                    autoFocus: false,
                    autoComplete: "off",
                    search: false,
                    borderColor: "#9b9b9b",
                    elevation: "0",
                    placeholder: "Enter Name",
                    size: "medium",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",
                  id: makeid(),
                  properties: {
                    type: "number",
                    name: "text",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Age",
                    autoFocus: false,
                    autoComplete: "off",
                    search: false,
                    borderColor: "#9b9b9b",
                    elevation: "0",
                    placeholder: "Enter Age",
                    size: "medium",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "TapSelect",
                  component_type: "qdm",
                  name: "TapSelect",
                  id: makeid(),
                  properties: {
                    type: "single",
                    fullWidth: false,
                    selectedBorderColor: "#1890ff",
                    selectedBackgroundColor: "#fff",
                    selectedTextColor: "#1890ff",
                    textSize: "small",
                    iconHeight: 20,
                    iconWidth: 20,
                    textColor: "#000",
                    label: "Gender",
                    options: [
                      {
                        value: "Male",
                        label: "Male",
                      },
                      {
                        value: "Female",
                        label: "Female",
                      },
                      {
                        value: "Others",
                        label: "Others",
                      },
                    ],
                    iconPosition: "left",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",
                  id: makeid(),
                  properties: {
                    type: "number",
                    name: "Mobile number",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Mobile Number",
                    autoFocus: false,
                    autoComplete: "off",
                    search: false,
                    borderColor: "#9b9b9b",
                    elevation: "0",
                    placeholder: "Enter mobile number",
                    size: "medium",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: "6",
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "20px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "TextInput",
                  component_type: "qdm",
                  name: "TextInput",
                  id: makeid(),
                  properties: {
                    type: "text",
                    name: "text",
                    variant: "outlined",
                    helperTextType: "error",
                    label: "Provider Address",
                    autoFocus: false,
                    autoComplete: "off",
                    search: false,
                    borderColor: "#9b9b9b",
                    elevation: "0",
                    placeholder: "Enter Address",
                    size: "medium",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "stretch",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                marginBottom: "30px",
              },
            },
            {
              type: "component",
              component: "Col",
              component_type: "qdm",
              name: "Col",
              id: makeid(),
              child: [
                {
                  type: "component",
                  component: "Button",
                  component_type: "qdm",
                  name: "Button",
                  id: makeid(),
                  properties: {
                    type: "button",
                    variant: "outlined",
                    name: "Save",
                  },
                  inlineStyles: {},
                },
              ],
              properties: {
                name: "qdm-col-12",
                alignItems: "flex-start",
                direction: "row",
                justify: "flex-start",
                textAlign: "left",
                lg: 12,
                xs: 12,
                md: 12,
                sm: 12,
              },
              inlineStyles: {
                display: "flex",
                justifyContent: "flex-end",
              },
            },
          ],
          properties: {
            alignItems: "stretch",
            direction: "row",
            justify: "flex-start",
            spacing: 2,
          },
          inlineStyles: {
            padding: "20px",
          },
        },
      ],
    },
  },
];

/// component prop-list provider json --unused
export const eleAtrribute = {
  // Button: {
  //   properties: {
  //     disabled:''
  //   }
  // },
  // ///maxlength and labelwidth not working ... diabled problem hangs
  // TextInput: {
  //   properties: {
  //   },
  // },
  // Col: {
  //   properties: {
  //   },
  //   inlineStyles: {
  //   },
  // },
  // ///fluid inherition not working
  // Container: {
  //   properties: {
  //   },
  //   inlineStyles: {
  //     display: "flex",
  //     flexDirection: "",
  //     alignItems: "",
  //     justifyContent: "",
  //     color: "",
  //     fontSize: 12,
  //     fontWeight: "",
  //     backgroundColor: "",
  //     border: "",
  //   },
  // },
  // ////to text input ,,,what is elipsisrow
  // H1: TypoGraphy,
  // H2: TypoGraphy,
  // H6: TypoGraphy,
  // Text: TypoGraphy,
  // ///noclick event , nothing working ,,inlinetextstyles find a solution
  // Checkbox: {
  //   properties: {
  //     label: "Checkbox",
  //     size: "medium",
  //     color: "primary",
  //     defaultChecked: "true",
  //     disabled: "true",
  //     checked: "true",
  //   },
  // },
  // BorderLinearProgress: {
  //   properties: {
  //     color: "secondary",
  //     variant: "determinate",
  //   },
  // },
  // //// handling no name access , inLineAlertTextStyles?: object, inLineAlertCloseStyles?: object, --find a way ,, way to add tezt inside styles
  // Alert: {
  //   properties: {
  //     name: "This is an Alert",
  //     variant: "filled",
  //     severity: "success",
  //   },
  //   inlineStyles: {},
  // },
  // ///has more properties to cover ---- backgroundColor not overriding
  // Divider: {
  //   properties: {
  //     orientation: "horizontal",
  //     variant: "fullWidth",
  //   },
  //   inlineStyles: {
  //     backgroundColor: "#fff",
  //     borderColor: "#f4f1f1",
  //     borderWidth: "1px",
  //     borderStyle: "solid",
  //     borderRadius: "0px",
  //     width: "auto",
  //     height: "auto",
  //   },
  // },
  // Card: {
  //   properties: {},
  //   inlineStyles: {
  //     color: "#eeeeee",
  //     fontSize: 12,
  //     fontWeight: "500",
  //     backgroundColor: "#fff",
  //     borderColor: "#f4f1f1",
  //     borderWidth: "1px",
  //     borderStyle: "solid",
  //     borderRadius: "0px",
  //     width: "auto",
  //     height: "auto",
  //   },
  // },
  // CardContent: {
  //   properties: {},
  //   inlineStyles: {
  //     color: "#eeeeee",
  //     fontSize: 12,
  //     fontWeight: "500",
  //     backgroundColor: "#fff",
  //     borderColor: "#f4f1f1",
  //     borderWidth: "1px",
  //     borderStyle: "solid",
  //     borderRadius: "0px",
  //     width: "auto",
  //     height: "auto",
  //   },
  // },
  // CardHeader: {
  //   properties: {
  //     title: "Card Heading",
  //     subHeader: "Card Sub Heading",
  //     avatar:
  //       "https://www.google.com/imgres?imgurl=https%3A%2F%2Fmedia-exp1.licdn.com%2Fdms%2Fimage%2FC560BAQHMnA03XDdf3w%2Fcompany-logo_200_200%2F0%2F1519855918965%3Fe%3D2159024400%26v%3Dbeta%26t%3DCrP5Le1mWICRcaxIGNBuajHcHGFPuyNA5C8DI339lSk&imgrefurl=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fimg&tbnid=d42LwtBDxTXoOM&vet=12ahUKEwi1u6z66uLuAhXCFysKHdwZBXoQMygAegUIARC6AQ..i&docid=huUCOMTfkRHQEM&w=200&h=200&q=img&ved=2ahUKEwi1u6z66uLuAhXCFysKHdwZBXoQMygAegUIARC6AQ",
  //   },
  //   inlineStyles: {
  //     color: "#eeeeee",
  //     fontSize: 12,
  //     fontWeight: "500",
  //     backgroundColor: "#fff",
  //     borderColor: "#f4f1f1",
  //     borderWidth: "1px",
  //     borderStyle: "solid",
  //     borderRadius: "0px",
  //     width: "auto",
  //     height: "auto",
  //   },
  // },
  // CardActions: {
  //   properties: {
  //     title: "Card Heading",
  //     subHeader: "Card Sub Heading",
  //     avatar:
  //       "https://www.google.com/imgres?imgurl=https%3A%2F%2Fmedia-exp1.licdn.com%2Fdms%2Fimage%2FC560BAQHMnA03XDdf3w%2Fcompany-logo_200_200%2F0%2F1519855918965%3Fe%3D2159024400%26v%3Dbeta%26t%3DCrP5Le1mWICRcaxIGNBuajHcHGFPuyNA5C8DI339lSk&imgrefurl=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fimg&tbnid=d42LwtBDxTXoOM&vet=12ahUKEwi1u6z66uLuAhXCFysKHdwZBXoQMygAegUIARC6AQ..i&docid=huUCOMTfkRHQEM&w=200&h=200&q=img&ved=2ahUKEwi1u6z66uLuAhXCFysKHdwZBXoQMygAegUIARC6AQ",
  //   },
  //   inlineStyles: {
  //     backgroundColor: "#fff",
  //     borderColor: "#f4f1f1",
  //     borderWidth: "1px",
  //     borderStyle: "solid",
  //     borderRadius: "0px",
  //     width: "auto",
  //     height: "auto",
  //   },
  // },
  // //image url not working ... image entry working after first edit
  // CardMedia: {
  //   properties: {
  //     image: "ff",
  //   },
  //   inlineStyles: {
  //     color: "#eeeeee",
  //     fontSize: 12,
  //     fontWeight: "500",
  //     backgroundColor: "#fff",
  //     borderColor: "#f4f1f1",
  //     borderWidth: "1px",
  //     borderStyle: "solid",
  //     borderRadius: "0px",
  //     width: "auto",
  //     height: "auto",
  //   },
  // },
  // Row: {
  //   properties: {
  //     direction: "row",
  //     alignItems: "stretch",
  //     justify: "flex-start",
  //     spacing: 2,
  //   },
  //   inlineStyles: {
  //     backgroundColor: "#fff",
  //     borderColor: "#f4f1f1",
  //     borderWidth: "1px",
  //     borderStyle: "solid",
  //     borderRadius: "0px",
  //     width: "auto",
  //     height: "auto",
  //   },
  // },
  // ////onclick not workin && component not changing
  // Link: {
  //   properties: {
  //     name: "Clik Here to Redirect",
  //     color: "primary",
  //     underline: "hover",
  //   },
  //   inlineStyles: {
  //     color: "#eeeeee",
  //     fontSize: 12,
  //     fontWeight: "500",
  //     backgroundColor: "#fff",
  //     borderColor: "#f4f1f1",
  //     borderWidth: "1px",
  //     borderStyle: "solid",
  //     borderRadius: "0px",
  //     width: "auto",
  //     height: "auto",
  //   },
  // },
  // ///Not Working --nothing
  // Switch: {
  //   properties: {
  //     label: "Checkbox",
  //     size: "medium",
  //     name: "Check Box",
  //     color: "primary",
  //     defaultChecked: "true",
  //     disabled: "true",
  //     checked: "true",
  //     indeterminate: "true",
  //   },
  // },
  // ///way to ad inlinetextstyles  inlinestyles
  // Radio: {
  //   properties: {
  //     label: "Radio",
  //     name: "Radio",
  //     color: "primary",
  //     value: "true",
  //     checked: "true",
  //     defaultChecked: "true",
  //     disabled: "true",
  //     indeterminate: "true",
  //   },
  // },
};
